import { useQuery } from "react-query";
import { API_KEY_GET_FRODER } from "../constants";
import { getFroder } from "../api";

export const useGetFroder = (id) => {
  return useQuery([API_KEY_GET_FRODER, id], () => getFroder(id));
};
